// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1WXlN","row":"Node_row__98LPo","label":"Node_label__2WihI","footer":"Node_footer__1qAQM"};